module.exports = __webpack_public_path__ + "static/media/17_r_stena_83.7_0.1d229be2.png";